import { render, staticRenderFns } from "./Doctor.vue?vue&type=template&id=5d7ff5f7&scoped=true&lang=pug"
import script from "./Doctor.vue?vue&type=script&lang=js"
export * from "./Doctor.vue?vue&type=script&lang=js"
import style0 from "./Doctor.vue?vue&type=style&index=0&id=5d7ff5f7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7ff5f7",
  null
  
)

export default component.exports